import React, { Component } from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import { Route, Routes } from 'react-router-dom'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'
import { connect } from 'react-redux';
import { withRouter } from '../../withRouter'
import * as auth from '../../sections/auth/reducer'
import Login from '../../sections/auth/Login'
import Home from '../../sections/home'
import Authenticated from '../../sections/auth/Authenticated'
import MobileTest from '../../sections/mobile-test'

const Container = styled.div`
    display: flex;
    flex: 1;
    flex-direction: row;
    height: 100%;
`



class Main extends Component {

    componentDidMount() {

        const { dispatch } = this.props

        dispatch(auth.sides.fetch())
    }

    componentDidUpdate() {

        if (!this.props.auth.loading) {
            if (this.props.auth.user === null && this.props.location.pathname !== '/login') {
                this.props.history.push('/login')
            }

            else if (this.props.auth.user !== null && this.props.location.pathname === '/login') {
                this.props.history.push('/authenticated')
            }
        }
    }

    render() {

        const { location, auth } = this.props

        return (
            <Container className="main-container">

                {auth.loading &&

                    <CircularProgress />
                }

                {(!auth.loading && auth.user === null) &&

                    <Routes>
                        <Route path="/login" element={<Login />} />
                    </Routes>
                }

                {(!auth.loading) &&

                    <Routes>
                        <Route path="/mobile" element={<MobileTest />} />
                    </Routes>
                }

                {(!auth.loading && auth.user !== null && location.pathname != '/mobile') &&

                    <div style={{ width: '100%' }}>
                        <div>
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/authenticated" element={<Authenticated />} />
                            </Routes>
                        </div>
                    </div>
                }
            </Container >
        );
    }

    static propTypes = {
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }
}

export default connect(state => state)(withRouter(Main))
